import React from "react";
import { useFormContext } from "react-hook-form";
import CField, { CFieldInputProps } from "$forms/CField";
import CompanySelect from "$forms/CompanySelect";
import { CompanyType } from "$types";
import { useDockyardFormContext } from "../context/DockyardFormContext";
import { useDockyardStyles } from "../styles";
import useAuth from "$hooks/useAuth";

export const CompanySection: React.FC = () => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { dockyard, defaultValuesForm } = useDockyardFormContext();
  const classes = useDockyardStyles();
  const { isAdmin } = useAuth();

  return (
    <div className={classes.newFormFieldsRow}>
      <CField
        control={control}
        disabled={Boolean(dockyard) || defaultValuesForm?.company || !isAdmin()}
        name="company"
        required
        error={errors.company}
      >
        {(props: CFieldInputProps) => (
          <CompanySelect
            {...props}
            minCharsToTrigerSearch={0}
            rowsPerPage={99999}
            companyTypes={[CompanyType.CLIENT]}
            onChange={(data) => {
              props.onChange(data);
              if (data) {
                setValue("project", null);
                setValue("contact", null);
              }
            }}
          />
        )}
      </CField>
    </div>
  );
};
